var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"miniDocs"},[_c('h3',{staticClass:"miniDocs-title"},[_vm._v(_vm._s(_vm.title))]),_c('ul',{staticClass:"miniDocs_list"},_vm._l((_vm.listData),function(doc,i){return _c('mini-doc',{key:i,attrs:{"doc-data":doc}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }